import axios from "axios";
import React, { useEffect, useState } from "react";
import gold from "../../../images/goldMedal.svg";
import silver from "../../../images/silverMedal.svg";
import bronze from "../../../images/bronzeMedal.svg";
import downloadIcon from "../../../images/searchBarDownload.svg";
import NoDataIcon from "../../../images/NoDataIcon";
import { CiFilter } from "react-icons/ci";
import { set } from "date-fns";
import ImageLoading from "../../../components/ImageLoading";

const NewTableUsers = ({ checkPledged }) => {
  const [filterValue, setFilterValue] = useState("Mutual Funds");
  const [loading, setLoading] = useState(false);
  const dropDownValues = [
    {
      name: "Mutual Funds",
    },
    {
      name: "Bank",
    },
    {
      name: "Vehicle",
    },
    {
      name: "Stocks",
    },
    {
      name: "NPS",
    },
    {
      name: "Real Estates",
    },
  ];

  const [topUsers, setTopUsers] = useState([]);

  const [hasPledgedFund, setHasPledgedFund] = useState(true);

  const [dropDownShow, setDropDownShow] = useState(false);

  const getTopPledgedMutualFunds = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/dashboards/top_users_networth`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      //   console.log(res.data.top_pledged_mutual_funds);
      if (!res.data?.top_users_networth?.length) setHasPledgedFund(false);
      else {
        setHasPledgedFund(true);
      }
      setTopUsers(res.data.top_users_networth);
      setLoading(false);
    } catch (error) {}
  };

  useEffect(() => {
    getTopPledgedMutualFunds();
    // setTopUsers(data);
  }, []);
  function formatToIndianRupees(num) {
    if (num === null || num === undefined) return "---";
    // Convert the number to a string
    if (typeof num === "string") num = parseFloat(num);
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  const findValueofGroup = (data, group) => {
    if (group === "NPS") group = "National Pension Systems";
    const groupData = data.find((item) => item.group === group);
    return groupData?.value;
  };

  checkPledged(hasPledgedFund);
  const handleDropDown = () => {
    setDropDownShow(!dropDownShow);
  };

  const handleFilterClick = (name) => {
    setFilterValue(name);
    setDropDownShow(false);
  };
  function truncateString(str) {
    if (!str) return "";
    const maxLength = 20;
    if (str.length <= maxLength) {
      return str;
    } else {
      return str.substring(0, maxLength) + "...";
    }
  }

  return (
    <>
      {loading ? (
        <div className="flex w-full h-full justify-center items-center">
          <ImageLoading />
        </div>
      ) : (
        <>
          <div className="bg-white h-full overflow-y-scroll rounded-lg">
            <p className="text-[16px] font-semibold  ml-4 mt-[17px] mb-[14px]">
              Top 5 Users&#39; Net Worth
            </p>

            <table className="w-full relative">
              <thead className=" bg-[#e6ebed] text-sm">
                <th className="w-[15%] ">No.</th>
                <th className="text-left  w-[30%] ">User Name</th>
                <th className="text-left  w-[30%]">Total NetWorth</th>
                <th className=" text-left flex h-[36px] items-center justify-between max-w-[160px]">
                  <p className="">{filterValue}</p>
                  <button
                    onClick={handleDropDown}
                    onBlur={() => {
                      setTimeout(function () {
                        setDropDownShow(false);
                      }, 300);
                    }}
                    className=" p-[4px]  bg-white rounded border border-[#dadada] mr-[20px]"
                  >
                    <CiFilter fontSize={"17px"} />
                  </button>
                  {dropDownShow && (
                    <div className="absolute right-[24px] top-[34px] pb-2 text-xs font-semibold flex flex-col h-[140px] min-w-[123px] bg-white shadow-md rounded-b-lg overflow-y-scroll">
                      {dropDownValues.map((item, index) => (
                        <button
                          key={index}
                          className=" py-3 px-[10px] hover:bg-[#f1f1f1]"
                          onClick={() => handleFilterClick(item.name)}
                        >
                          {item.name}
                        </button>
                      ))}
                    </div>
                  )}
                </th>

                {/* <th className=" w-[20%]">Total Net Worth</th> */}
              </thead>

              <tbody className=" text-center text-xs font-medium">
                {topUsers?.map((item, index) => (
                  <tr
                    key={index}
                    className={` ${
                      index % 2 === 0 ? "bg-[#ffffff]" : "bg-[#f8f8f8]"
                    }`}
                  >
                    <td className=" h-[36px]">{index + 1}</td>
                    <td
                      className="text-left"
                      title={
                        item.name !== null && item?.name?.length > 20
                          ? item.name
                          : ""
                      }
                    >
                      {truncateString(item.name) || "---"}
                    </td>
                    <td className="text-left ">
                      {formatToIndianRupees(item.total_networth)}
                    </td>
                    {/* <td className="">{item.name}</td> */}
                    <td className="text-left">
                      {formatToIndianRupees(
                        findValueofGroup(item.data, filterValue)
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}{" "}
    </>
  );
};

export default NewTableUsers;
